import { MembershipMetaFragmentDoc } from "@pathwright/graphql-client/src/generated"

export default MembershipMetaFragmentDoc
